import request from '@/utils/request'

/**
 * 修改员工密码
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象
 */
export function changeStaffPwd(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.changeStaffPwd',
      method: 'post',
      data,
      emulateJSON: true
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}